export const SECURED_INSTALLMENTS_DEFAULT_PRODUCT = 'INSTALLMENT_LOAN_SECURED'
export const PAYLATER_DEFAULT_PRODUCT = 'PAY_LATER'
export const ACTIVATION_PAGE_KIND = 'card activation'
export const ACTIVATION_ANALYTICS_PROPS = {
  ACTIVATION_PAGE_KIND: 'card activation',
  ACTIVATION_PAGE_FUNCTION: 'activate your account'
}
